export enum Generics {
    REGION = 'region',
    GLOBAL_REGION_FILTER = 'Global Region Filter',
  }
  